<template>
  <div></div>
</template>

<script>
  import wxapi from '@/assets/js/wxapi.js';
    export default {
        name: 'WxShare',
        created() {
          let self = this
          this.axios.get(self.serverUrl + 'share/weixin?url='+ encodeURIComponent(window.location.href.split('#')[0]))
            .then(function (response) {
            // console.log(response.data);
            let data = response.data
            wxapi.wxRegister(data, self.share2wx)
          })
            .catch(function (error) {
            console.log(error);
          });
      }
    }
</script>



// WEBPACK FOOTER //
// src/components/WxShare.vue